<dashboard-dialog-frame [icon]='icon()' header='Set Event' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="final-presentation-set-event-dialog">
		<readonly-access [readonly]="isReadonly()"></readonly-access>
		<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
			<tr>
				<td style="width: 20%;">Event</td>
				<td>
					<droplist  [items]='events()' [selectedItem]='selectedItem()' [readonly]="isReadonly()"
						(selectionChange)='onViewDroplistChange($event)'>
					</droplist>
				</td>
			</tr>
		</table>
	</div>

</dashboard-dialog-frame>